export const TransferRequestTypeEnum = {
  BetweenInsigniaAccount: 'BetweenInsigniaAccount',
  OtherInsigniaAccount: 'OtherInsigniaAccount',
  OtherBankTransfer: 'OtherBankTransfer',
  CardAccountSettlement: 'CardAccountSettlement',
} as const;
export type TransferRequestTypeEnum = (typeof TransferRequestTypeEnum)[keyof typeof TransferRequestTypeEnum];
